export * from './diagnose.service';